import axios from 'axios';
import { LanguageObject } from '@/i18n';

interface FunctionalCenter {
  id?: number;
  code: string;
}

const api = {
  list: async (params?: { activeonly?: boolean }) => {
    const resp = await axios.get<FunctionalCenter[]>(
      '/functionalCentres/list.php',
      { params: params }
    );
    return resp.data;
  },
  get: async (id: number) => {
    const resp = await axios.get<FunctionalCenter>(
      '/functionalCentres/get.php',
      {
        params: { id: id },
      }
    );
    return resp.data;
  },
  add: async (functionalcentre: Partial<FunctionalCenter>) => {
    const resp = await axios.post<FunctionalCenter>(
      '/functionalCentres/add.php',
      functionalcentre
    );
    // console.log('add resp', resp.data);
    return resp.data;
  },
  update: async (functionalcentre: Partial<FunctionalCenter>) => {
    const resp = await axios.post<FunctionalCenter>(
      '/functionalCentres/update.php',
      functionalcentre
    );
    // console.log('update resp', resp.data);
    return resp.data;
  },
  remove: async (id: number) => {
    await axios.delete('/functionalCentres/delete.php', {
      params: { id: id },
    });
  },
};

export default {
  api,
};

export { FunctionalCenter };
